import { useEffect, useState } from "react";
import { _AccountantConcept, _CompetitionType, _Entailment, _MainTheme } from "../../../../core/services/dataBean/EntityCatalog";

import { Singleton } from "../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { PrintJson } from "../../../theme/Component/PrintJson";
import { PrintObjectJson } from "../../../theme/Component/PrintObjectJson";
import { CashReimbursementServices } from "../CashDesk/CashReimbursement/CashReimbursement-service";
import { SelectAccountantTree } from "../../../contabilidad/catalogo-cuentas/AccountantTree/SelectAccountantTree";
import { MASK_DATE } from "../../../theme/Component/BasicTable2";
import { BasicSwitch } from "../../../theme/Component/BasicSwitch";
import { SelectBudgetID } from "../../../admin/configuracion/BudgetID/SelectBudgetID";
import { AccountEditor } from "../../../editor/AccountEditor";
import { SelectFunctionalID } from "../../../admin/configuracion/functionalID/SelectFunctionalID";
import { SelectBudgetTypes } from "./SelectBudgetTypes";
import { SelectTypeProcees } from "../../../Talentohumano/GestionTH/PaymentAccount/SelectTypeProcees";
import { IncomeResponsibleConceptSelect } from "../../../Factoty&Production/IncomeResponsibleConcept/IncomeResponsibleConceptSelect";
import { SelectorDocumentFactory } from "../../../contabilidad/bodegaDocumentos/SelectorDocumentFactory";
import usePaginator from "../../../theme/Component/usePaginator";
import { CashFlowConceptSelect } from "../CashFlowConcept/CashFlowConcepSelect";
import { SelectBudgetType } from "../../../admin/configuracion/select/SelectBudgetType";
import { SelectBusinessCore } from "../BusinessCore/SelectBusinessCore";



export const AccountantConcept = () => {

    const AccountantConcept = useDataBean(_AccountantConcept);

    const single = Singleton.getInstance();
    const service = new CashReimbursementServices();
    const [selectedItems, setSelectedItems] = useState([]);
    const [lista, setLista] = useState<any>([]);
    const [listadocs, setlistadocs] = useState([]);
    const [ProcessType, setProccesType] = useState<number>(null)
    const [regexStr, setregexStr] = useState<string>(null)
    const [income, setincome] = useState<number>(null)
    const [doc, setDoc] = useState<number>(null)
    const [flow, setFlow] = useState<number>(null)
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const paginador = usePaginator();
    const [records, setRecords] = useState<number>(15);

    useEffect(() => {
        getLista();
        getListaDocs();
    }, [ProcessType, regexStr, flow, doc, income, paginador.page])

    const handleCheckboxChange = (event, item) => {
        const isChecked = event.target.checked;
        let updatedItems = [];

        // Obtener JsonList actual de la fila en edición
        let currentJsonList = AccountantConcept.bean.JsonList
            ? JSON.parse(AccountantConcept.bean.JsonList)
            : [];

        if (isChecked) {
            updatedItems = [...currentJsonList, item.DocumentFactory];
        } else {
            updatedItems = currentJsonList.filter(selected => selected !== item.DocumentFactory);
        }

        // 🔹 Solo actualiza la fila en edición, NO todas las filas
        AccountantConcept.setBean({
            ...AccountantConcept.bean,
            JsonList: JSON.stringify(updatedItems ?? '[]'),
        });
    };

    useEffect(() => {
        if (modal.view) {  // 🔹 Solo actualizar cuando el modal está abierto
            AccountantConcept.setBean(prev => ({
                ...prev,
                JsonList: JSON.stringify(selectedItems),
            }));
        }
    }, [selectedItems]);


    const getLista = () => {
        AccountantConcept.instance.getAccountantConceptCatalog(ProcessType, regexStr, income, flow, doc, paginador.page, records).then(
            (resp: any) => {
                if (resp) {
                    //console.log(resp.NumberOfPages)
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (records));
                    paginador.setRegiPerPage(records)

                    setLista(resp.List)
                }
            }
        )
    }

    const create = () => {
        AccountantConcept.setBean({
            ProcessType: AccountantConcept.bean.ProcessType,
            IDIncomeResponsible: AccountantConcept.bean.IDIncomeResponsible,
            ApplyForCashDesk: false,
            SendToFunctionalArea: false,
            RequiresBudgetID: false,
        });
        setSelectedItems([]);

        // AccountantConcept.update().then(
        //     (resp: any) => {
        //        //console.log(resp);
        //     }
        // );
        setModal({ ...modal, "view": true });
    }


    const deleteItem = () => {
        AccountantConcept.deleteItemVoid(AccountantConcept.bean.IDAccountantConcept).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {

        //console.log(AccountantConcept.bean);
        AccountantConcept.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const head = [
        { title: 'ID', property: 'IDAccountantConcept', visible: true },
        { title: 'Código', property: 'Code', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Unidad de Negocio', property: 'BusinessCoreName', visible: true },
        { title: 'Tipo de Presupuesto', property: 'AccountantTypeName', visible: true },
        { title: 'Cuenta Contable del Concepto ', property: 'AccountantIDName', visible: true },
        { title: 'Cuenta Puente Contabilización', property: 'CreditAccountantIDName', visible: true },
        { title: 'Aplica a Cajas Menores', property: 'ApplyForCashDesk', visible: true },
        { title: 'Lista de Documentos a los que Aplica', property: 'JsonListName', visible: true },
        { title: 'Fecha de Creación', property: 'Since', visible: true, mask: MASK_DATE },
        { title: 'Rubro Presupuestal', property: 'BudgetName', visible: true },
        { title: 'No requiere compensación', property: 'DontRequiresCompensation', visible: true },
        { title: 'Tipo de Proceso', property: 'ProcessTypeName', visible: true },
        { title: 'Utilizar Responsable Compensación / Ingreso', property: 'CashFlowConceptName', visible: true },
        { title: 'Reponsable de Compensación de Ingreso', property: 'IncomeResponsibleName', visible: true }
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [

            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    const getListaDocs = () => {

        single.spinner(true);
        service.getDocumentFactoryCatalog(null).subscribe(
            (resp: any) => {

                if (resp.DataBeanProperties.ObjectValue) {
                    setlistadocs(resp.DataBeanProperties.ObjectValue);
                }
                single.spinner(false);
            }
        );
    }
    const toJson = (valor: any) => {
        let json: any = [];
        try {
            json = JSON.parse(valor);
        } catch (error) {

        }
        return json;
    }


    return (
        <BasicPage titulo="Catálogo de Conceptos Contables - Cuentas por Pagar">
            <div className="row">
                <div className="col-md-4">
                    <SelectTypeProcees label='Tipo de Proceso' idSelector={ProcessType} onChange={(e: any) => { setProccesType(e) }} />
                </div>
                <div className="col-md-4">
                    <label>Búsqueda por Texto</label>
                    <input type="text" name="Name" className="form-control" value={regexStr} onChange={(e: any) => { setregexStr(e.target.value) }} />
                </div>
                <div className="col-md-4">

                    <SelectorDocumentFactory label="Tipo de Documento" id={doc} onChange={(e) => { setDoc(e.DocumentFactory); console.log(e) }} />

                </div>
                <div className="col-md-4">
                    <CashFlowConceptSelect idSelector={flow} onChange={(e) => { setFlow(e) }} />
                </div>
                <div className="col-md-4">
                    <IncomeResponsibleConceptSelect label='Compensación de Ingreso' idSelector={income} onChange={(e: any) => { setincome(e) }} />
                </div>
                <div className="col-md-12">

                    <BasicTable body={lista} head={head} rowSet={AccountantConcept.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} pageTop={paginador.page}
                        next={paginador.next}
                        back={paginador.back}
                        records={paginador}
                        customRows={records}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">

                            <div className="col-md-12">
                                <label>Nombre</label>
                                <input type="text" name="Name" className="form-control" value={AccountantConcept.bean.Name} onChange={AccountantConcept.handleChange} />

                            </div>
                            <div className="col-md-12 table-limit mt-3">



                                <div className="table-responsive">
                                    <table className="table" >
                                        <thead >
                                            <tr className="trtable">
                                                <th className="thtable">Seleccionar</th>
                                                <th className="thtable">Mnemonic</th>
                                                <th className="thtable">Nombre</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {Array.isArray(listadocs) && listadocs.map((Docs: any, index: number) => {

                                                let isChecked = false;
                                                const jsonList = toJson(AccountantConcept.bean.JsonList);

                                                if (jsonList && Array.isArray(jsonList)) {
                                                    isChecked = jsonList.includes(Docs?.DataBeanProperties?.DocumentFactory);
                                                }

                                                return (
                                                    <tr className="trtable" key={index}>
                                                        <td className="tdtable">
                                                            <input
                                                                type="checkbox"
                                                                name="JsonList"
                                                                checked={isChecked}
                                                                onChange={(e) => handleCheckboxChange(e, Docs.DataBeanProperties)}
                                                            />
                                                        </td>
                                                        <td className="tdtable">{Docs.DataBeanProperties.Mnemonic}</td>
                                                        <td className="tdtable">{Docs.DataBeanProperties.Name}</td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>

                            </div>
                            {/* <PrintJson json={AccountantConcept.bean} /> */}
                            <div className="col-md-6">
                                <SelectAccountantTree label="Cuenta Contable del Concepto" idAccountant={AccountantConcept.bean.AccountantID} onChange={(e) => { AccountantConcept.setBean({ ...AccountantConcept.bean, "AccountantID": e.AccountantID, "AccountantIDStr": e.JsonCode }) }} />
                            </div>
                            <div className="col-md-6">
                                <SelectAccountantTree label="Cuenta Puente Contabilización" idAccountant={AccountantConcept.bean.CreditAccountantID} onChange={(e) => { AccountantConcept.setBean({ ...AccountantConcept.bean, "CreditAccountantID": e.AccountantID, "CreditAccountantIDStr": e.JsonCode }) }} />
                            </div>

                            <div className="col-md-6">
                                <BasicSwitch estado={AccountantConcept.bean.RequiresBudgetID} eventChange={(e) => { AccountantConcept.setBean({ ...AccountantConcept.bean, "RequiresBudgetID": e }) }} label="Requiere Rubro Presupuestal" />
                            </div>
                            <div className="col-md-6">
                                <label>Rubro Presupuestal</label>
                                <SelectBudgetID label=" " tipoPresupuesto={null} edit={false} onChange={(e) => { AccountantConcept.setBean({ ...AccountantConcept.bean, "BudgetIDStr": e.JsonCode }) }} jsonCode={AccountantConcept.bean.BudgetIDStr} />
                            </div>

                            <div className="col-md-6">
                                <CashFlowConceptSelect idSelector={AccountantConcept.bean.IDCashFlowConcept} onChange={(e) => { AccountantConcept.setBean({ ...AccountantConcept.bean, "IDCashFlowConcept": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <SelectBudgetTypes label="Tipo Concepto" idSelector={AccountantConcept.bean.AccountantType} onChange={(e) => { AccountantConcept.setBean({ ...AccountantConcept.bean, "AccountantType": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <BasicSwitch estado={AccountantConcept.bean.ApplyForCashDesk} eventChange={(e) => { AccountantConcept.setBean({ ...AccountantConcept.bean, "ApplyForCashDesk": e }) }} label="Aplica a Cajas Menores" />
                            </div>
                            <div className="col-md-6">
                                <label>Código</label>
                                <input type="text" name="Code" className="form-control" value={AccountantConcept.bean.Code} onChange={(e) => { AccountantConcept.setBean({ ...AccountantConcept.bean, "Code": parseFloat(e.target.value) }) }} />
                            </div>
                            <div className="col-md-6">
                                <SelectBusinessCore label='Unidad de Negocio' returnType="Object" idSelector={AccountantConcept.bean.IDBusinessCore} onChange={(e) => { AccountantConcept.setBean({ ...AccountantConcept.bean, "IDBusinessCore": e.IDBusinessCore, "BusinessCoreCodeName": `${e.Code} - ${e.Name}` }) }} />
                            </div>
                            <div className="col-md-6">
                                <SelectTypeProcees label='Tipo de Proceso' idSelector={AccountantConcept.bean.ProcessType} onChange={(e) => { AccountantConcept.setBean({ ...AccountantConcept.bean, "ProcessType": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <SelectBudgetType label="Tipo de Presupuesto" idSelector={AccountantConcept.bean.IDBudgetType} onChange={(e: any) => { AccountantConcept.setBean({ ...AccountantConcept.bean, "IDBudgetType": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <BasicSwitch estado={AccountantConcept.bean.DontRequiresCompensation} eventChange={(e) => { AccountantConcept.setBean({ ...AccountantConcept.bean, "DontRequiresCompensation": e }) }} label="No requiere compensación" />
                            </div>
                            <div className="col-md-6">
                                <BasicSwitch estado={AccountantConcept.bean.UseIncomeResponsible} eventChange={(e) => { AccountantConcept.setBean({ ...AccountantConcept.bean, "UseIncomeResponsible": e }) }} label="Utilizar Responsable de Compensación de Ingreso ?" />
                            </div>
                            {AccountantConcept.bean.UseIncomeResponsible &&
                                <>
                                    <IncomeResponsibleConceptSelect idSelector={AccountantConcept.bean.IDIncomeResponsible} onChange={(e) => { AccountantConcept.setBean({ ...AccountantConcept.bean, "IDIncomeResponsible": e }) }} />
                                </>
                            }
                            {/* <div className="col-md-6">
                                <BasicSwitch estado={AccountantConcept.bean.SendToFunctionalArea} eventChange={(e) => { AccountantConcept.setBean({ ...AccountantConcept.bean, "SendToFunctionalArea": e }) }} label="Solicitar Detalle del Area Funcional" />
                            </div>
                            <div className="col-md-6">
                                <SelectFunctionalID onChange={(e) => { AccountantConcept.setBean({ ...AccountantConcept.bean, "IDLnFunctionalArea": e }) }} functionalIDLn={AccountantConcept.bean.IDLnFunctionalArea} label="Área Funcional Encargada" />
                            </div>
                            <div className="col-md-6">
                                <AccountEditor idAccount={AccountantConcept.bean.IDAccountFunctionalArea} label="Responsable en el Área Funcional" onChange={(e) => { AccountantConcept.setBean({ ...AccountantConcept.bean, "IDAccountFunctionalArea": e.IDAccount }) }} />
                            </div> */}
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}